/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { images_GenerateUploadURLRequest } from '../models/images_GenerateUploadURLRequest';
import type { images_ImageHistoryResponse } from '../models/images_ImageHistoryResponse';
import type { images_ImageResponse } from '../models/images_ImageResponse';
import type { images_ListImagesResponse } from '../models/images_ListImagesResponse';
import type { services_GenerateUploadURLResponse } from '../models/services_GenerateUploadURLResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ImagesService {
    /**
     * List images for an entity
     * Lists all images associated with a specific entity. Parents are restricted to entityType=child with their own children's IDs.
     * @param entityType Entity type (e.g., employee, child, contact)
     * @param entityId Entity ID; required unless entityIds is supplied
     * @param entityIds Entity IDs, max 100. Serialized as REPEATED query keys (entityIds=a&entityIds=b), which is what the generated clients emit; a single comma-separated value is also accepted server-side. MUTUALLY EXCLUSIVE with entityId — supplying both is rejected with 400. Only supported for entityType=portfolio_entry. An id the caller may not read yields an ABSENT entry, never an error. Each entity returns at most its 100 most recent images, newest first, exactly as the singular form pages them; an entity with more is truncated and has no continuation cursor.
     * @param limit Limit (singular entityId form only; the batched entityIds form is fixed at 100 images per entity)
     * @param offset Offset (singular entityId form only)
     * @returns images_ListImagesResponse Singular form (entityId). The BATCHED form (entityIds) returns a DIFFERENT body — an images object keyed by entity id, each value an array of ImageResponse; see the ListImagesByEntitiesResponse type. An id with no photos, and an id the caller may not read, are both simply absent from that map. The schema below documents the singular form only: this spec is Swagger 2.0, which cannot express a response union, and the caller selects the form with the parameter it sends.
     * @throws ApiError
     */
    public static getApiV1Images(
        entityType: string,
        entityId?: string,
        entityIds?: Array<string>,
        limit: number = 20,
        offset?: number,
    ): CancelablePromise<images_ListImagesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/images',
            query: {
                'entityType': entityType,
                'entityId': entityId,
                'entityIds': entityIds,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Invalid parameters`,
                401: `Unauthorized`,
                403: `Organization ID not found`,
                500: `Failed to list images`,
            },
        });
    }
    /**
     * Delete an image
     * Soft deletes an image from the system
     * @param id Image ID
     * @returns void
     * @throws ApiError
     */
    public static deleteApiV1Images(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/images/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Organization ID not found`,
                404: `Image not found`,
                500: `Failed to delete image`,
            },
        });
    }
    /**
     * Get image details
     * Retrieves image metadata and generates a temporary download URL. Parents can only access images of their own children.
     * @param id Image ID
     * @returns images_ImageResponse OK
     * @throws ApiError
     */
    public static getApiV1Images1(
        id: string,
    ): CancelablePromise<images_ImageResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/images/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Organization ID not found`,
                404: `Image not found`,
                500: `Failed to get image`,
            },
        });
    }
    /**
     * Confirm that an image upload was completed
     * Confirms that an image was successfully uploaded to storage and updates its status.
     * Validates that the uploaded file's content matches its declared Content-Type using magic bytes.
     * For images bound to a portfolio entry, media consent is re-checked against the persisted entity
     * before the image is marked completed. Consent revoked after the upload URL was issued rejects the confirm.
     * @param id Image ID
     * @returns images_ImageResponse OK
     * @throws ApiError
     */
    public static postApiV1ImagesConfirm(
        id: string,
    ): CancelablePromise<images_ImageResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/images/{id}/confirm',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid or missing image ID, or upload not completed`,
                401: `Unauthorized`,
                403: `Organization ID not found`,
                404: `Image not found`,
                413: `File too large`,
                422: `File content validation failed, or media consent not granted for this portfolio entry`,
                500: `Failed to confirm upload`,
            },
        });
    }
    /**
     * Get image audit history
     * Retrieves the audit history for an image. Parents can only access history of their own children's images.
     * @param id Image ID
     * @param limit Limit
     * @param offset Offset
     * @returns images_ImageHistoryResponse OK
     * @throws ApiError
     */
    public static getApiV1ImagesHistory(
        id: string,
        limit: number = 20,
        offset?: number,
    ): CancelablePromise<images_ImageHistoryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/images/{id}/history',
            path: {
                'id': id,
            },
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                401: `Unauthorized`,
                403: `Organization ID not found`,
                404: `Image not found`,
                500: `Failed to get image history`,
            },
        });
    }
    /**
     * Generate a presigned URL for image upload
     * Generates a presigned URL that can be used to upload an image directly to storage.
     *
     * **Validation rules for entityType and entityId:**
     * - For purpose "avatar": Both fields are REQUIRED
     * - For purposes "attachment" and "document": Both fields are OPTIONAL
     * - When one field is provided, the other must also be provided (they must be used together)
     *
     * **Purpose values:**
     * - "avatar": Profile pictures for entities (requires entityType and entityId)
     * - "attachment": File attachments for entities (entityType and entityId optional, can be associated later)
     * - "document": General documents (entityType and entityId optional)
     * - "export": REJECTED — exports are system-generated and cannot be uploaded by a client
     * @param request Upload URL request
     * @returns services_GenerateUploadURLResponse OK
     * @throws ApiError
     */
    public static postApiV1ImagesUploadUrl(
        request: images_GenerateUploadURLRequest,
    ): CancelablePromise<services_GenerateUploadURLResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/images/upload-url',
            body: request,
            errors: {
                400: `Invalid request, or purpose 'export' which is not available for client uploads`,
                401: `Unauthorized`,
                403: `Organization ID not found`,
                413: `File too large`,
                415: `Unsupported media type`,
                422: `Media consent not granted for this portfolio entry, or a restricted entityType (employee_absence_certificate)`,
                500: `Failed to generate upload URL`,
            },
        });
    }
}
